import { BaseModifiersKey } from './index';

export const DEFAULT_MODIFIERS_CLASS_NAMES: Record<BaseModifiersKey, string> = {
  disabled: '-disabled',
  selected: '-selected',
  today: '-today',
  selectedStart: '-selected-start',
  selectedMiddle: '-selected-middle',
  selectedEnd: '-selected-end',
};
